import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { TopLayer } from '@app/core/layers/top-layer';
import { NotificationService } from '@app/core/notifications/notification.service';

@Component({
  selector: 'app-notification-center',
  templateUrl: './notification-center.html',
  styleUrl: './notification-center.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationCenter {
  private readonly service = inject(NotificationService);
  protected readonly notifications = this.service.notifications;

  constructor() {
    // Los avisos van siempre encima de todo: TopLayer los muda adentro del modal o la carga de más arriba.
    inject(TopLayer).pinNotifications(inject<ElementRef<HTMLElement>>(ElementRef).nativeElement);
  }

  protected dismiss(id: number): void {
    this.service.dismiss(id);
  }
}
